
import {applyMixin} from "@/mixins/applyMixin";

export default {
  components: {},
  mixins: [applyMixin],
  data() {
    return {
      breadcrumbList: [
        {
          title: '解决方案',
          path: null
        },
        {
          title: '网络质量监测系统',
          path: null
        }
      ], // 面包屑导航的数组
      topInfoLists: [
        {
          title1: '运营商家宽与专线网络质量检测与监测',
          title2: '对家庭宽带和专线网络进行检测与监测，实时获取终端用户的网络质量与感知，减少运营商与用户间的感知偏差，用户网络问题及时预警、高效解决，助力网络高质量发展',
          leftTile1: '用户主动测试',
          leftTile2: '终端用户使用测速网检测工具主动发起测试',
          rightTile1: '系统拨测',
          rightTile2: '使用网络质量监测系统下发拨测任务测试',
          leftImg: require('@/assets/imgs/quality-monitoring/left1.png'),
          rightImg: require('@/assets/imgs/quality-monitoring/right1.png'),
        },
        {
          title1: '工业互联网设备与网络质量监测',
          title2: '实时监测企业与园区的设备联网状态与质量，支持多种操作系统和设备类型，可检测多项指标，内外网环境均可使用。',
          leftTile1: '用户主动测试',
          leftTile2: '终端用户使用测速网检测工具主动发起测试',
          rightTile1: '系统拨测',
          rightTile2: '使用网络质量监测系统下发拨测任务测试',
          leftImg: require('@/assets/imgs/quality-monitoring/left2.png'),
          rightImg: require('@/assets/imgs/quality-monitoring/right2.png'),
        }, {
          title1: '校园网网络质量与用户感知监测',
          title2: '支持用户主动测试和系统下发任务自动检测，可安装在用户上网设备上，也可部署定制的监测设备，7/24执行检测任务，全面了解校园网网络质量和用户实际感知，助力网络优化。',
          leftTile1: '师生测试工具',
          leftTile2: '师生使用测速网检测工具主动发起测试',
          rightTile1: '系统拨测',
          rightTile2: '使用网络质量监测系统下发拨测任务测试',
          leftImg: require('@/assets/imgs/quality-monitoring/left3.png'),
          rightImg: require('@/assets/imgs/quality-monitoring/right3.png'),
        },
      ],
      bottomInfo1: [{
        title1: '下载速度',
        title2: '通过测试下载数据的速度来<br/>确定网络连接的下行带宽',
        img: require('@/assets/imgs/quality-monitoring/down.png')
      }, {
        title1: '上传速度',
        title2: '通过测试上传数据的速度来<br/>确定网络连接的上行带宽',
        img: require('@/assets/imgs/quality-monitoring/up.png')
      }, {
        title1: '时延',
        title2: '通过测试网络连接的时延<br/>（毫秒）来了解连接质量',
        img: require('@/assets/imgs/quality-monitoring/delay.png')
      }, {
        title1: '抖动',
        title2: '通过测试时延的波动来<br/>诊断网络抖动',
        img: require('@/assets/imgs/quality-monitoring/logo.png')
      }, {
        title1: '丢包',
        title2: '统计并展示网络连接的<br/>丢包情况',
        img: require('@/assets/imgs/quality-monitoring/loss.png')
      }],
      bottomInfo2: [{
        title1: '网页打开时间',
        title2: '测试用户终端打开<br/>网页的时间',
        img: require('@/assets/imgs/quality-monitoring/open.png')
      }, {
        title1: '应用访问时延',
        title2: '测试用户终端访问<br/>资源的时延',
        img: require('@/assets/imgs/quality-monitoring/yydelay.png')
      }]
    }
  },
}
